import { useState as l, useLayoutEffect as n } from "react";
import { createPortal as s } from "react-dom";
const a = "modal", u = "motif-modal-root", m = () => {
  const t = document.createElement("div");
  return t.setAttribute("id", a), t.setAttribute("class", u), document.body.appendChild(t), t;
}, f = ({ children: t }) => {
  const [o, d] = l();
  return n(() => {
    let e = document.getElementById(a), r = !1;
    return e || (e = m(), r = !0), d(e), () => {
      r && e.parentNode && e.parentNode.removeChild(e);
    };
  }, []), o ? s(t, o) : null;
};
export {
  f as default
};
